module.exports = __webpack_public_path__ + "static/media/lifestyle_5.820b9608.jpg";